import useSearchParams from 'hooks/useSearchParams';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useLocalizedNavigate from '~/hooks/useLocalizedNavigate';

interface ValidateExperienceSearchParams {
  maxPeople: number;
}

function useValidateExperienceSearchParams({
  maxPeople = 4,
}: ValidateExperienceSearchParams) {
  const searchParams = useSearchParams();
  const navigate = useLocalizedNavigate();
  const location = useLocation();
  useEffect(() => {
    const numberOfAdults = parseInt(searchParams.get('adults') || '4', 10);
    const numberOfChildren = parseInt(searchParams.get('children') || '0', 10);
    if (numberOfAdults + numberOfChildren > maxPeople) {
      searchParams.set('adults', String(maxPeople));
      searchParams.set('children', '0');
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
          hash: location.hash,
        },
        { replace: true, state: location.state },
      );
    }
  }, [searchParams, maxPeople, navigate, location]);

  return null;
}

export default useValidateExperienceSearchParams;
